import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input_container field-wrapper" }
const _hoisted_2 = { class: "right-section" }
const _hoisted_3 = { class: "step-arrows" }

import { ref, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'inputField',
  props: {
  modelValue: {
    type: [String, Number],
    default: ''
  },
  labelText: {
    type: String,
    default: '20,00 - 50.000,00'
  },
  maxLimit: {
    type: Number,
    default: 50000
  }
},
  emits: ['update:modelValue', 'valueChanged'],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

const localValue = ref(props.modelValue)

watch(() => props.modelValue, (newVal) => {
  localValue.value = newVal  
})

watch(localValue, (val) => {
  emit('update:modelValue', val)
  emit('valueChanged', val)
})

const handleMaxClick = () => {
  localValue.value = props.maxLimit
}

const increment = () => {
  const val = Number(localValue.value) || 0
  localValue.value = val + 1
}

const decrement = () => {
  const val = Number(localValue.value) || 0
  if (val > 0) localValue.value = val - 1
}

const onClear = () => {
  localValue.value = ''
  emit('update:modelValue', '')
  emit('valueChanged', '')
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_field = _resolveComponent("van-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_field, {
      modelValue: localValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localValue).value = $event)),
      type: "number",
      placeholder: __props.labelText,
      class: _normalizeClass(["custom-field", { 'has-value': localValue.value }]),
      border: false
    }, {
      "left-icon": _withCtx(() => _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "left-section" }, [
          _createElementVNode("span", { class: "left_icon" }, "R$")
        ], -1)
      ])),
      button: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (localValue.value)
            ? (_openBlock(), _createBlock(_component_van_icon, {
                key: 0,
                name: "clear",
                class: "custom-clear",
                onClick: _withModifiers(onClear, ["stop"])
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_icon, {
              name: "arrow-up",
              class: "step-icon",
              onClick: increment
            }),
            _createVNode(_component_van_icon, {
              name: "arrow-down",
              class: "step-icon",
              onClick: decrement
            })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "max-btn",
            onClick: _withModifiers(handleMaxClick, ["stop"])
          }, " Máx. ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "class"])
  ]))
}
}

})